import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {JhiEventManager, JhiParseLinks} from 'ng-jhipster';
import {GiongService} from '@entities/giong/giong.service';
import {Subscription} from 'rxjs';
import {ITEMS_PER_PAGE, PAGE_SIZE_OPTIONS} from '@app/shared';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {HttpResponse} from '@angular/common/http';
import {GiongDetail, IHistoryGiong} from '@entities/giong/giong.model';

@Component({
  selector: 'app-giong-detail',
  templateUrl: './giong-detail.component.html',
})
export class GiongDetailComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'tbWarehouseName',
    'tbBlockDetailsCode',
    'updateDate',
    'action',
    'quantity',
    'description',
    'actions',
  ];
  giongDetail: GiongDetail;
  dataSource: any;
  pageSizeOptions: number[];
  ELEMENT_DATA: IHistoryGiong[];
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  noData: boolean;
  isLoading = true;
  eventSubscriber: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    private eventManager: JhiEventManager,
    private parseLinks: JhiParseLinks,
    private giongService: GiongService,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.ELEMENT_DATA = [];
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
    this.giongDetail = new GiongDetail();
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(({giong, pagingParams}) => {
      this.page = pagingParams.page;
      this.previousPage = pagingParams.page;
      this.reverse = pagingParams.ascending;
      this.predicate = pagingParams.predicate;
      setTimeout(() => {
        if (giong !== undefined) {
          this.giongDetail = giong;
          this.loadAll();
          this.changeListSupply();
        }
      }, 0);
    });
  }

  ngOnDestroy() {
    this.eventManager.destroy(this.eventSubscriber);
  }
  changeListSupply() {
    this.eventSubscriber = this.eventManager.subscribe(
      'giongListModification',
      () => {
        this.loadAll();
        this.loadDetail();
      },
    );
  }
  loadAll() {
    this.isLoading = true;
    this.giongService
      .vatTuHistory(this.giongDetail.tbSuppliesDTO.id, {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      })
      .subscribe((res: HttpResponse<IHistoryGiong[]>) =>
        this.onSuccess(res.body, res.headers, 'historySupplies'),
      );
  }
  loadDetail() {
    this.giongService.find(this.giongDetail.tbSuppliesDTO.id).subscribe(
      (res) => this.onSuccess(res.body, res.headers, 'detailSupplies'),
      (res) => this.onError(res),
    );
  }
  private onError(error: any) {
    this.isLoading = false;
  }
  private onSuccess(data: any, headers: any, type: string) {
    this.isLoading = false;
    if (type === 'historySupplies') {
      this.links = this.parseLinks.parse(headers.get('link'));
      this.totalItems = headers.get('X-Total-Count');
      this.queryCount = this.totalItems;
      this.ELEMENT_DATA = data;
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      if (data.length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    }
    if (type === 'detailSupplies') {
      this.giongDetail = data;
    }
  }
  private sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }
  loadPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize;
    this.loadAll();
  }
}
